import institutionAPI from 'services/institutionAPI'
import toast from 'utils/toast'

type Params = {
  alertTypeSlug?: string
}

export default async function getValidAlertType({ alertTypeSlug }: Params) {
  const response = await institutionAPI({
    method: 'GET',
    url: `/alert/case/case-type/${alertTypeSlug}`,
  })

  if (!response?.header?.success) {
    toast.error(response?.header?.message)
  }

  return response
}
